import { EmpeDriveApiClient } from '@/api-clients/empe-drive-client';
import { Album } from '@/models/album';

export const getAlbums = async (limit: number = 1) => {
    return await EmpeDriveApiClient.get<Album[]>(`/albums?limit=${limit}`);
};
